// extracted by mini-css-extract-plugin
export var animationContainer = "_ik-0";
export var footer = "_ik-1";
export var gray = "_ik-2";
export var lineItem = "_ik-3";
export var lineItemImage = "_ik-4";
export var lineItemInfo = "_ik-5";
export var lineItemText = "_ik-6";
export var lineItems = "_ik-7";
export var modalContent = "_ik-8";
export var options = "_ik-9";
export var orderName = "_ik-a";
export var refundAmount = "_ik-b";